import { Input } from "src/features/calculator/types/formula"

const THRESHOLD_RENT = 100_000
const HIGH_FEE_RATE = 0.66
const LOW_FEE_RATE = 0.55
// 送客手数料率(税込 = もし家賃が >= 100000 ならば0.66それ以外は0.55
export function calcCustomerTransferFeeRate({ rent }: Input): number {
  return rent >= THRESHOLD_RENT ? HIGH_FEE_RATE : LOW_FEE_RATE
}
